import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom'
import { BgColor } from '../Color/Color'

function Siderbar() {
    const menuItem = [

        {
            id: 1,
            name: "Home",
            link: "",
            icon: "house-fill",
        },
        {
            id: 2,
            name: "Addmission",
            link: "addmission",
            icon: "people-fill",
        },
        {
            id: 3,
            name: "Student Pdf",
            link: "student",
            icon: "person-fill",
        },
        {
            id: 4,
            name: "Academic",
            link: "academic",
            icon: "calendar-week-fill",
        },
        {
            id: 5,
            name: "Topper",
            link: "topper",
            icon: "trophy-fill",
        },
        {
            id: 6,
            name: "Course",
            link: "course",
            icon: "book-half",
        },

        {
            id: 7,
            name: "Gallery",
            link: "gallery",
            icon: "image-fill",
        },
        {
            id: 8,
            name: "Category",
            link: "category",
            icon: "grid",
        },
        {
            id: 9,
            name: "Video",
            link: "video",
            icon: "file-play-fill",
        },
        {
            id: 10,
            name: "Blogs",
            link: "blog",
            icon: "grid-fill",
        },
        {
            id: 11,
            name: "News",
            link: "news",
            icon: "grid-fill",
        },
        {
            id: 12,
            name: "Facilites",
            link: "facilites",
            icon: "building-fill-gear",
        },
        {
            id: 13,
            name: "Medical Facilites",
            link: "medicalFacilites",
            icon: "heart-pulse-fill",
        },
        {
            id: 14,
            name: "Departments",
            link: "department",
            icon: "person-fill-gear",
        },
        {
            id: 15,
            name: "About",
            link: "about",
            icon: "question-circle-fill",
        },

        {
            id: 16,
            name: "Forms & query",
            link: "feedback",
            icon: "question-octagon-fill",
        },
        {
            id: 17,
            name: `Notification`,
            link: "notification",
            icon: "bell-fill",
        },

    ]
    return (
        <div
            className="d-flex flex-column flex-shrink-0"
        >
            <NavLink
                to="/"
                className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none py-2"
            >
                <span className="fs-5 fw-bold text-white">Admin</span>
            </NavLink>
            {/* <hr /> */}
            <ul className="nav nav-pills flex-column mb-auto">
                {
                    menuItem.map((_) => (
                        <li className="nav-item" key={_.id}>
                            <NavLink to={_.link} className={({ isActive }) => `nav-link text-white ${isActive ? `bg-${BgColor} dark` : ""}`}>
                                <i className={`bi bi-${_.icon} me-2`}>
                                </i>
                                {_.name}
                            </NavLink>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

export default Siderbar